import { styled } from '@linaria/react'
import React, { useState } from 'react'
import brazil from '../../assets/flags/brazil.webp'
import china from '../../assets/flags/china.webp'
import india from '../../assets/flags/india.webp'
import indonesia from '../../assets/flags/indonesia.webp'
import korea from '../../assets/flags/korea.webp'
import mexico from '../../assets/flags/mexico.webp'
import thailand from '../../assets/flags/thailand.webp'
import vietnam from '../../assets/flags/vietnam.webp'

const Container = styled.div`
  position: relative;
  svg {
    stroke: var(--secondary-txt);
  }
`

const Flag = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 6px;
`

const Label = styled.p`
  font-size: 14px;
  color: var(--txt);
  font-family: 'Poppins';
  white-space: nowrap;
`

const Divider = styled.div`
  width: 2px;
  border-radius: 2px;
  height: 20px;
  margin: 0 4px 0 8px;
  background-color: var(--secondary-txt);
`

const Dropdown = styled.div`
  background-color: var(--primary);
  position: absolute;
  top: 20px;
  right: 0;
  padding: 6px 16px;
  border-radius: 6px;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);
  pointer-events: none;
  transition: all 0.2s ease-in-out;
  opacity: 0;
  &.active {
    top: 30px;
    opacity: 1;
    pointer-events: auto;
  }
`

const FLAGS = [
  {
    icon: mexico,
    label: 'Español',
    link: '',
  },
  {
    icon: brazil,
    label: 'Português',
    link: 'https://www.fun88br.com',
  },
  {
    icon: china,
    label: '中文',
    link: 'https://fun1689.com',
  },
  {
    icon: india,
    label: 'English',
    link: 'https://www.fun-88.in',
  },
  {
    icon: indonesia,
    label: 'Bahasa Indonesia',
    link: 'https://seru88bekasi.com',
  },
  {
    icon: korea,
    label: '한국어',
    link: 'https://www.fun88.kr',
  },
  {
    icon: thailand,
    label: 'ภาษาไทย',
    link: 'https://www.fun701.com/th/',
  },
  {
    icon: vietnam,
    label: 'Tiếng việt',
    link: 'https://www.fun601.com/vn/',
  },
]

const LanguageSelector = () => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <Divider />
      <Container>
        <button className="flx-str-ctr" onClick={() => setIsOpen(prev => !prev)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            width="30"
            height="30">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
            />
          </svg>
        </button>
        <Dropdown className={isOpen ? 'active' : ''}>
          {FLAGS.slice(1).map(flag => (
            <div
              key={flag.label}
              className="flx-str-ctr"
              style={{ height: 35 }}
              onClick={() => {
                window.location.href = flag.link
              }}>
              <Flag src={flag.icon} alt={flag.label} />
              <Label>{flag.label}</Label>
            </div>
          ))}
        </Dropdown>
      </Container>
    </>
  )
}

export default LanguageSelector
